import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { GridComponent, ColumnsDirective, ColumnDirective, Inject, Sort, Filter, Search, Toolbar, VirtualScroll } from '@syncfusion/ej2-react-grids';

import Loader from '../components/Loader';
import ListDoxExt from '../components/ListDoxExt';
import ListSite from '../components/ListSite';
import ListDeclaration from '../components/ListDeclaration';
import ListDoc from '../components/ListDoc';
import ListDommage from '../components/ListDommage';
import ListContact from '../components/ListContact';
import FinanceTab from '../components/FinanceTab';

import useFetchDeclarations from '../hooks/useFetchDeclarations';
import useFetchSites from '../hooks/useFetchSites';
import useFetchDoxExt from '../hooks/useFetchDoxExt';
import useFetchDommages from '../hooks/useFetchDommages';
import useFetchDocs from '../hooks/useFetchDocs';
import useFetchIntervenants from '../hooks/useFetchIntervenants';

import { formatDate, formatCurrency } from '../utils/Format';
import AutoResizeTextarea from '../utils/AutoResizeTextarea';

const DeclarationDetail = () => {
    const { uuid } = useParams();

    const { intervenant, fetchIntervenantByUUID, contacts, fetchContactsByIntervenantUUID, relIntervenants, fetchRelationsIntervenantsBySocieteUUID } = useFetchIntervenants();

    const [activeTab, setActiveTab] = useState('coord');

    useEffect(() => {
        if (uuid) {
            fetchIntervenantByUUID(uuid);
            fetchContactsByIntervenantUUID(uuid);
            fetchRelationsIntervenantsBySocieteUUID(uuid);
        }
    }, [uuid]);

    if (!intervenant) {
        return <div class="flex flex-1 justify-center items-center"><Loader /></div>;
    }

    console.log(intervenant);
    console.log("contacts", contacts);
    console.log("relIntervenants", relIntervenants);

    const combi = relIntervenants.concat(contacts);

    return (

        <div class="flex-1 px-4 lg:px-8">
            <div class="gap-6 grid grid-cols-12">
                <div class="gap-6 grid grid-cols-12 col-span-12 xxl:col-span-9">
                    <div class="col-span-12">
                        <div class="flex items-center bg-gray-900 drop-shadow-xl mb-6 px-8 rounded-lg w-full h-20">
                            <div id="url" class="flex flex items-center gap-x-2 font-semibold text-gray-400 text-sm sm:text-lg">
                                <Link to="/intervenants" class="hover:text-white decoration-orange-600 hover:underline hover:underline-offset-2 transition hover:translate-y-[-2px] duration-300">Intervenants</Link>
                                <span class="cursor-default">/</span>
                                <Link to={"/intervenants/" + intervenant.UUID_} class="hover:text-orange-600 transition hover:translate-y-[-2px] duration-300">
                                    {intervenant.Nom}
                                </Link>
                            </div>
                        </div>

                        <div className="mx-auto w-full">
                            <div className="mb-4 border-gray-200 border-b">
                                <ul className="flex flex-wrap -mb-px" role="tablist">
                                    {[
                                        { id: 'coord', label: 'Coordonnées' },
                                        { id: 'sites', label: 'Sites' },
                                        { id: 'declas', label: 'Déclarations' },
                                        { id: 'doms', label: 'Dommages' },
                                        { id: 'contacts', label: 'Contacts' },
                                        // { id: 'dommages', label: 'Dommages' },
                                        // { id: 'exp', label: 'Expertises' },
                                        // { id: 'finances', label: 'Infos Financières' },
                                        // { id: 'docs', label: 'Documents Externes' },
                                    ].map((tab) => (
                                        <li key={tab.id} className="mr-2" role="presentation">
                                            <button
                                                className={`text-base font-semibold text-center py-4 px-4 rounded-t-lg border-b-5 ${activeTab === tab.id
                                                    ? 'text-orange-600 borde-2 border-orange-300 '
                                                    : 'text-orange-400 border-transparent hover:text-orange-500'
                                                    } transition duration-300 ease-in-out`}
                                                onClick={() => setActiveTab(tab.id)}
                                                type="button"
                                                role="tab"
                                                aria-controls={tab.id}
                                                aria-selected={activeTab === tab.id}
                                            >
                                                {tab.label}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div id="myTabContent">
                                {activeTab === 'coord' && (
                                    <div id="form-info" className="mx-auto">
                                        <div className="bg-white shadow-lg mb-6 p-4 md:p-8 px-4 rounded-lg">

                                            {/* Informations Générales */}
                                            <div id="general-info" className="gap-4 gap-y-2 grid grid-cols-2 md:grid-cols-10 text-sm">
                                                <h2 className="col-span-10 font-semibold text-lg">Informations Générales</h2>

                                                <div className="md:flex gap-4 gap-y-2 col-span-10">
                                                    <div className="flex-1 mb-2">
                                                        <label>Nom</label>
                                                        <input className="bg-orange-50 mt-1 px-4 border rounded-lg w-full h-10 font-bold cursor-text"
                                                            value={intervenant.Nom} disabled />
                                                    </div>
                                                    <div className="flex-1 mb-2">
                                                        <label>Type</label>
                                                        <input className="bg-gray-50 mt-1 px-4 border rounded-lg w-full h-10 cursor-text"
                                                            value={intervenant._Type} disabled />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Lieu */}
                                            <div id="location-info" className="gap-4 gap-y-2 grid grid-cols-2 md:grid-cols-10 mt-6 text-sm">
                                                <h2 className="col-span-10 font-semibold text-lg">Lieu</h2>

                                                <div className="md:flex gap-4 gap-y-2 col-span-10">
                                                    <div className="flex-1 mb-2">
                                                        <label>Adresse</label>
                                                        <input className="bg-gray-50 mt-1 px-4 border rounded-lg w-full h-10 cursor-text"
                                                            value={intervenant.Adresse1} disabled />
                                                    </div>
                                                    <div className="flex-1 mb-2">
                                                        <label>Code Postal</label>
                                                        <input className="bg-gray-50 mt-1 px-4 border rounded-lg w-full h-10 cursor-text"
                                                            value={intervenant.CP} disabled />
                                                    </div>
                                                    <div className="flex-1 mb-2">
                                                        <label>Ville</label>
                                                        <input className="bg-gray-50 mt-1 px-4 border rounded-lg w-full h-10 cursor-text"
                                                            value={intervenant.Ville} disabled />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Contacts */}
                                            <div id="contact-info" className="gap-4 gap-y-2 grid grid-cols-2 md:grid-cols-10 mt-6 text-sm">
                                                <h2 className="col-span-10 font-semibold text-lg">Contacts</h2>

                                                <div className="md:flex gap-4 gap-y-2 col-span-10">
                                                    <div className="flex-1 mb-2">
                                                        <label>Téléphone</label>
                                                        <input className="bg-gray-50 mt-1 px-4 border rounded-lg w-full h-10 cursor-text"
                                                            value={intervenant.Tel} disabled />
                                                    </div>
                                                    <div className="flex-1 mb-2">
                                                        <label>Fax</label>
                                                        <input className="bg-gray-50 mt-1 px-4 border rounded-lg w-full h-10 cursor-text"
                                                            value={intervenant.Fax} disabled />
                                                    </div>
                                                    <div className="flex-1 mb-2">
                                                        <label>Email</label>
                                                        <input className="bg-gray-50 mt-1 px-4 border rounded-lg w-full h-10 cursor-text"
                                                            value={intervenant.Mail} disabled />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Historique de Création */}
                                            <div id="creation-history" className="gap-4 gap-y-2 grid grid-cols-2 md:grid-cols-10 mt-6 text-sm">
                                                <h2 className="col-span-10 font-semibold text-lg">Historique de Création</h2>

                                                <div className="md:flex gap-4 gap-y-2 col-span-10">
                                                    <div className="flex-1 mb-2">
                                                        <label>Date de Création</label>
                                                        <input className="bg-gray-50 mt-1 px-4 border rounded-lg w-full h-10 cursor-text"
                                                            value={intervenant._Date_Crea} disabled />
                                                    </div>
                                                    <div className="flex-1 mb-2">
                                                        <label>Date de Modification</label>
                                                        <input className="bg-gray-50 mt-1 px-4 border rounded-lg w-full h-10 cursor-text"
                                                            value={intervenant._Date_Modif} disabled />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                )}

                                {activeTab === 'sites' && (
                                    <ListSite lstSites={[]} />
                                )}
                                {activeTab === 'declas' && (
                                    <ListDeclaration lstDeclarations={[]}/>
                                )}
                                {activeTab === 'doms' && (
                                    <ListDommage lstDommages={[]} />
                                )}
                                {activeTab === 'contacts' && (
                                    <ListContact lstContacts={combi} intervenantUUID={uuid}/>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

};

export default DeclarationDetail;